module.exports = __WEBPACK_EXTERNAL_MODULE_12__;


//////////////////
// WEBPACK FOOTER
// external "oasi-widgets/dist/index.css"
// module id = 12
// module chunks = 0